import { apiAxios } from '../../../helpers'

export const getList = async matchId => {
  const result = await apiAxios.get('matches/' + matchId + '/events')
  return result.data.data.eventsCreated
}

export const getOne = async (matchId, eventId) => {
  const result = await apiAxios.get('matches/' + matchId + '/events/' + eventId)
  return result.data.data.eventCreated
}
